var html = {
  "id": '#beautyChef_questionnaire',
  "complete": '',
  "header": '',
  "body": '',
  "footer": ''
},
  questions = [],
  answerOrder = [],
  mainurl = "https://questionnaireau.thebeautychef.com",
  //mainurl = "https://42d32087.ngrok.io",
  currentQuestion = null,
  currentCursor = 0,
  uuid = "",
  questionnaireId = 0,
  categorySelectionQuestion = null,
  gutQuestionCategory = 'GJ',
  gutQuestionPositions = [],
  firstGutQuestionPosition = 0,
  emailPosition = 0,
  consecutiveGutQuestionPositions = [],
  ele = {
    "gutInput": '.gut__option input'
  },
  gutScore = 0;

$(document).ready(function () {
  if (location.search.indexOf('pos=') !== -1) {
    currentCursor = getPos();
  }
  initiate();
});

function getPos() {
  var parameterName = "pos";
  var result = null,
    tmp = [];
  var items = location.search.substr(1).split("&");
  for (var index = 0; index < items.length; index++) {
    tmp = items[index].split("=");
    if (tmp[0] === parameterName) result = decodeURIComponent(tmp[1]);
  }
  return result;
}

function initiate() {
  getJson();
  buildQuestionnaire();
  shortcutKey();
}

function getJson() {
  pageload('show');
  function getData() {
    return $.ajax({
      type: "GET",
      url: mainurl + "/api/initiate",
      dataType: "html"
    });
  }
  function handleData(data) {
    var response = JSON.parse(data);
    uuid = response.uuid;
    questions = response.questions;
    console.log(uuid);
    console.log(questions);

    var storageUUID = localStorage.getItem('uuid');
    if (storageUUID == uuid) {
      location.reload(true);
    }
    findEmailPosition();
    gutQuestionVariables();
    nextQuestion();
    pageload('hide');
  }
  getData().done(handleData);
}

function findEmailPosition() {
  for (var i = 0; i < questions.length; i++) {
    if (questions[i].answerType == 'email') {
      emailPosition = i;
    }
  }
}

function gutQuestionVariables() {
  for (var i = 0; i < questions.length; i++) {
    if (questions[i].questionCategory == gutQuestionCategory) {
      consecutiveGutQuestionPositions.push(i);
      gutQuestionPositions.push(i);
    }
  }
  firstGutQuestionPosition = consecutiveGutQuestionPositions[0];
  consecutiveGutQuestionPositions.splice(0, 1);
}

function pageload(state) {
  if (state == 'show') {
    var loadingHtml = '<div class="page-loading"><div class="spin-icon"></div></div>';
    $(html.id).prepend(loadingHtml);
  } else if (state == 'hide') {
    var $loading = $('.page-loading');
    if ($loading.length) {
      $loading.remove();
    }
  }
}

function nextQuestion(back = false) {
  if (currentQuestion == null && currentCursor == 0 && location.search.indexOf('pos=') == -1) {
    //Display first question
    answerOrder.push(0);
    currentQuestion = questions[0];
  } else {
    if (back == true) {
      currentCursor = answerOrder[answerOrder.length - 1];
    } else {
      currentCursor = getNextQuestion();
      answerOrder.push(currentCursor);
    }
    currentQuestion = questions[currentCursor];
  }
  renderQuestion();
}

function getNextQuestion() {
  let nextFound = false;
  let curPos = currentCursor;
  while (nextFound == false) {
    curPos++;
    if (curPos >= questions.length) {
      generateAnswers();
      break;
    } else {
      var registerCur = true;
      if (questions[curPos].scoreDisplay == 1) {
        if (gutScore < 11 || gutScore > 20) {
          registerCur = false;
        }
      }
      if (questions[curPos].answerType == 'email') {
      } else if (questions[curPos].ignore.length == 0) {
        if (registerCur == true) {
          return curPos;
        }
      } else if (questions[curPos].questionCategory == 'GJ' && curPos != firstGutQuestionPosition) {
        //Do not return if question is not the first question of the Gut Journey and is part of the Gut Journey questions
      } else {

        if (registerCur == true) {
          let ignore = questions[curPos].ignore;
          let i = 0;
          let indQuestionStatus = [];
          while (i < ignore.length) {

            let ig_answer = ignore[i].value;
            let mainQuestion = getQuestionById(ignore[i].baseQuestionId);
            let actualAnswer = null;
            let ignoreQuestionPos = false;
            for (var k = 0; k < questions.length; k++) {
              if (questions[k].id == ignore[i].baseQuestionId) {
                ignoreQuestionPos = k;
              }
            }
            for (var j = 0; j < answerOrder.length; j++) {
              if (answerOrder[j] == ignoreQuestionPos) {
                actualAnswer = mainQuestion.answered;
              }
            }
            let op = ignore[i].operator;
            if (op == "E") {
              if (valueValidation(actualAnswer, ig_answer) == true) {
                //given answer has matched. do not show the question
                indQuestionStatus.push(false);
              }
            } else if (op == "G") {
              if (numValidation(actualAnswer, ig_answer, op) == true) {
                indQuestionStatus.push(false);
              }
            } else if (op == "S") {
              if (numValidation(actualAnswer, ig_answer, op) == true) {
                indQuestionStatus.push(false);
              }
            } else if (op == "N") {
              if (valueValidation(actualAnswer, ig_answer) == false) {
                indQuestionStatus.push(false);
              }
            } else if (op == "CG") {
              if (countValidation(actualAnswer, ig_answer, op) == false) {
                indQuestionStatus.push(false);
              }
            } else if (op == "CL") {
              if (countValidation(actualAnswer, ig_answer, op) == false) {
                indQuestionStatus.push(false);
              }
            } else if (op == "CE") {
              if (countValidation(actualAnswer, ig_answer, op) == false) {
                indQuestionStatus.push(false);
              }
            }
            i++;
          }
          if (indQuestionStatus.length === 0) {
            //If a question has do not show ("false") value,
            return curPos;
          }
        }
      }
    }
  }
}

function countValidation(providedAnswers, requiredAnswer, operator) {
  if (providedAnswers) {
    if (operator == "CG") {
      if (providedAnswers.length > requiredAnswer) {
        return false;
      }
    } else if (operator == "CL") {
      if (providedAnswers.length < requiredAnswer) {
        return false;
      }
    } else if (operator == "CE") {
      if (providedAnswers.length == requiredAnswer) {
        return false;
      }
    }
    return true;
  } else {
    return null;
  }
}

function numValidation(providedAnswers, requiredAnswer, operator) {
  let i = 0;
  if (providedAnswers) {
    while (i < providedAnswers.length) {
      if (operator == "G") {
        if (providedAnswers[i] < requiredAnswer) {
          return false;
        }
      } else if (operator == "S") {
        if (providedAnswers[i] > requiredAnswer) {
          return false;
        }
      }
      i++;
    }
    //In order for the condition to return true, all array elements must pass the operator condition
    //One array element passing is not enough
    return true;
  } else {
    return null;
  }
}

function valueValidation(providedAnswers, requiredAnswer) {
  //Answer is an array
  if (providedAnswers) {
    if (providedAnswers.indexOf(requiredAnswer) !== -1) {
      return true;
    } else {
      return false;
    }
  } else {
    return null;
  }
}


function getQuestionById(id) {
  let i = 0;
  while (i < questions.length) {
    if (questions[i].id == id) {
      return questions[i];
    }
    i++;
  }
  return false;
}

function renderQuestion() {
  var options = currentQuestion.options,
    title = currentQuestion.questionText,
    answered = currentQuestion.answered,
    titleHtml = '',
    contentHtml = '',
    continueSvg = '<svg width="36" height="19" viewBox="0 0 36 19" fill="none" xmlns="http://www.w3.org/2000/svg"><line x1="35" y1="9.5" x2="4.37114e-08" y2="9.5" stroke="#231F20"/><line x1="35.3536" y1="9.35355" x2="26.3536" y2="18.3536" stroke="#231F20"/><line x1="34.6464" y1="9.35355" x2="25.6464" y2="0.353553" stroke="#231F20"/></svg>',
    placeholderImage = 'https://www.shorekids.co.nz/wp-content/uploads/2014/08/image-placeholder.jpg';

  var container = {
    "titleID": '#tbc-title',
    "contentID": '#tbc-content',
    "inputClass": '.tbc-input--class'
  };
  var content = {
    "contentInput": 'input' + container.inputClass
  };
  $(window).scrollTop(0);
  if (answerOrder.length < 2) {
    $('#beautyChef_questionnaire .footer .prev').addClass('visually-hidden');
  } else {
    $('#beautyChef_questionnaire .footer .prev').removeClass('visually-hidden');
  }
  if (currentCursor == firstGutQuestionPosition) {
    //Gut Journey
    titleHtml += '<h1>How often do you?</h1><span class="strike">Please select from \'Never\', \'Sometimes\' or \'Often\' for each of the below questions.</span>';
    $(container.titleID).html(titleHtml);
    $(container.contentID).html(contentHtml); //Empty to regenerate

    contentHtml += '<div class="gut__wrapper">' +
      '<div class="gut__question-wrapper gut__header-wrapper">' +
      '<div class="gut__question-label"></div>' +
      '<div class="gut__option-label">Never</div>' +
      '<div class="gut__option-label">Sometimes</div>' +
      '<div class="gut__option-label">Often</div>' +
      '</div>';

    $(gutQuestionPositions).each(function (i, gutQuestionPosition) {
      var gutQuestion = questions[gutQuestionPosition];
      answered = gutQuestion.answered;
      contentHtml += '<div class="gut__question-wrapper">' +
        '<div class="gut__question" id="gut-' +
        gutQuestionPosition +
        '-">' +
        gutQuestion.questionText +
        '</div>';
      $(options).each(function (i, option) {
        var optionId = option.id,
          optionName = option.value;

        contentHtml += '<div class="gut__option"><input name="' +
          gutQuestion.id +
          '" type="radio" data-id="' +
          gutQuestion.id +
          '" id="' +
          gutQuestion.id +
          '-' +
          optionName +
          '" value="' +
          optionId +
          '" data-score="';
        if (optionName.toLowerCase().indexOf('never') !== -1) {
          contentHtml += '0';
        } else if (optionName.toLowerCase().indexOf('sometimes') !== -1) {
          contentHtml += '1';
        } else if (optionName.toLowerCase().indexOf('often') !== -1) {
          contentHtml += '2';
        }
        contentHtml += '"';
        if (answered) {
          $(answered).each(function (i, value) {
            if (value == optionId) {
              contentHtml += ' checked="checked"';
              return false;
            }
          });
        }
        contentHtml += '>' +
          '<label for="' +
          gutQuestion.id +
          '-' +
          optionName +
          '" onclick="postGutAnswer(' + gutQuestion.id + ', ' + optionId + ')"></label></div>';
      });

      contentHtml += '</div>';
    });

    contentHtml += '</div>';
    $(container.contentID).html(contentHtml);

  } else if (currentQuestion.id === questions[questions.length - 1].id) {
    if (title.indexOf('//') >= 0) {
      titleHtml += '<h1>' + title.split('//')[0] + '</h1>';
    } else {
      titleHtml += '<h1>' + title + '</h1>';
    }
    $(container.titleID).html(titleHtml);
    $(container.contentID).html(contentHtml); //Empty to regenerate	
    var questionId = currentQuestion.id,
      compulsoryMessage = $('.tnc-messaging .compulsory').html(),
      answerType = 'email';

    contentHtml += '<div class="tbc-input--container tncs">' +
      '<input id="' +
      questionId +
      '" class="tbc-input--class" type="' +
      answerType +
      '" ';
    contentHtml += ' required placeholder="Your Email">' +
      '<button class="btn--continue" type="button" onclick="saveAnswer()"></button></div>';
    contentHtml += '<div class="checkbox tnc-checkbox">' +
      '<span class="asterisk">*</span><input type="checkbox" name="compulsory" id="' +
      currentQuestion.id +
      '-compulsory" required><label for="' +
      currentQuestion.id +
      '-compulsory">' + compulsoryMessage + '</label>' +
      '</div>'
    contentHtml += '<div class="checkbox tnc-checkbox">' +
      '<input type="checkbox" name="optional" id="' +
      currentQuestion.id +
      '-klaviyo" value="true';
    contentHtml += '"><label for="' +
      currentQuestion.id +
      '-klaviyo">' +
      title.split('//')[1] +
      '</label></div>'
    $(container.contentID).html(contentHtml);


  } else {
    if (title.indexOf('//') >= 0) {
      titleHtml += '<h1>' + title.split('//')[0] + '</h1><span class="strike">' + title.split('//')[1] + '</span>'
    } else {
      titleHtml += '<h1>' + title + '</h1>';
    }
    $(container.titleID).html(titleHtml);
    $(container.contentID).html(contentHtml); //Empty to regenerate
    var answerType = currentQuestion.answerType,
      questionId = currentQuestion.id;

    if (answerType == 'text' || answerType == 'number' || answerType == 'email') {
      contentHtml += '<div class="tbc-input--container">' +
        '<input id="' +
        questionId +
        '" class="tbc-input--class" type="' +
        answerType +
        '" ';
      if (answered) {
        contentHtml += 'value="' +
          answered +
          '" ';
      }
      contentHtml += ' required>' +
        '<button class="btn--continue" type="button" onclick="saveAnswer()">' +
        continueSvg +
        '</button>' +
        '</div>';

      $(container.contentID).html(contentHtml);
      $(content.contentInput)[0].focus();

    } else if (answerType == "drop") {

      var dropOptions = currentQuestion.options;
      contentHtml += '<div class="tbc-select--container"><select class="tbc-select" name="' +
        questionId +
        '" onchange="saveAnswer()">';

      $(dropOptions).each(function (i, option) {
        let optionId = option.id,
          optionName = option.value;
        contentHtml += '<option value="' + optionId + '"';

        if (answered) {
          $(answered).each(function (i, value) {
            if (value == optionId) {
              contentHtml += ' selected';
              return false;
            }
          });
        }

        contentHtml += '>' + optionName + '</option>';

      });

      contentHtml += '</select></div>';

      $(container.contentID).html(contentHtml);

    } else if (answerType == "single" || answerType == "multi") {

      var options = currentQuestion.options,
        inputType = 'checkbox',
        questionId = currentQuestion.id;
      if (answerType == "single") {
        inputType = 'radio';
      }

      $(options).each(function (i, option) {
        var optionId = option.id,
          optionName = option.value,
          optionDescription = option.prettydescription,
          optionImage = option.imageurl;

        contentHtml += '<div class="tbc-multi--container tbc-' +
          inputType +
          '">' +
          '<input type="' +
          inputType +
          '" id="' +
          optionId +
          '" class="tbc-multi--class tbc-multi--' +
          inputType +
          '-class';
        if (option.noOption === 1) {
          contentHtml += ' noOption';
        }
        contentHtml += '" name="' +
          questionId +
          '" value="' +
          optionId +
          '"';
        if (answered) {
          $(answered).each(function (i, value) {
            if (value == optionId && option.noOption !== 1) {
              contentHtml += ' checked="checked"';
              return false;
            }
          });
        }
        if (inputType == 'radio') {
          contentHtml += ' onclick="saveAnswer()"';
        } else if (option.noOption === 1) {
          contentHtml += ' onclick="saveAnswer()"';
        }
        if (inputType == 'checkbox') {
          contentHtml += ' onclick="checkboxLimit(this, ' + currentQuestion.maxAnswers + ')"';
        }
        contentHtml += '><label for="' +
          optionId + '">';

        if (ValidURL(optionImage)) {
          contentHtml += '<img class="tbc-multi--image" src="' + optionImage + '" alt="' +
            optionName + '">';
        }
        contentHtml += '<span class="tbc-multi--title">';
        if (optionName.indexOf('//') >= 0) {
          contentHtml += optionName.split('//')[0] + '<span class="small">' + optionName.split('//')[1] + '</span>'
        } else {
          contentHtml += optionName;
        }
        contentHtml += '</span>';
        if (optionDescription && optionDescription != "-") {
          contentHtml += '<span class="tbc-multi--description">' +
            optionDescription +
            '</span>';
        }
        contentHtml += '</label>' +
          '</div>';
      });

      $(container.contentID).html(contentHtml);

      var containers = $('.tbc-multi--container'),
        largestWidth = 0;

      containers.each(function (i, container) {
        var containerWidth = $(container).outerWidth();
        if (containerWidth > largestWidth) {
          largestWidth = containerWidth;
        }
      });

      containers.css('width', largestWidth + 'px');

    }
  }
}

function pushDataLayer(currentCursor) {
  var stage = ''
  switch(currentCursor) {
    case 0:
      stage = 'YR-GEN-01'
      break
    case 1:
      stage = 'YR-GEN-02'
      break
    case 2:
      stage = 'YR-GEN-02'
      break
    case 3:
      stage = 'YR-GEN-03'
      break
    case 4:
      stage = 'YR-GEN-04'
      break
    case 6:
      stage = 'YR-GEN-05'
      break
    case 8:
      stage = 'YR-GEN-06'
      break
    case 9:
      stage = 'YR-GEN-07'
      break
    case 10:
      stage = 'YR-GEN-08'
      break
    case 11:
      stage = 'YR-GUT-01'
      break
    case 12:
      stage = 'YR-GUT-02'
      break
    case 13:
      stage = 'YR-GUT-03'
      break
    case 32:
      stage = 'YR-GEN-09'
      break
    case 33:
      stage = 'YR-SKIN-01'
      break
    case 34:
      stage = 'YR-SKIN-01A'
      break
    case 35:
      stage = 'YR-SKIN-01B'
      break
    case 36:
      stage = 'YR-SKIN-01C'
      break
    case 37:
      stage = 'YR-SKIN-02'
      break
    case 38:
      stage = 'YR-SKIN-02A'
      break
    case 39:
      stage = 'YR-GEN-10'
      break
    case 40:
      stage = 'YR-WELL-01'
      break
    case 41:
      stage = 'YR-WELL-01A'
      break
    case 42:
      stage = 'YR-WELL-02'
      break
    case 43:
      stage = 'YR-WELL-02A'
      break
    case 44:
      stage = 'YR-WELL-02B'
      break
    case 45:
      stage = 'YR-WELL-02C'
      break
    case 46:
      stage = 'YR-GEN-10'
      break
    case 41:
      stage = 'YR-GEN-11'
      break
  }
  if(stage != '') {
    window.dataLayer = window.dataLayer || []; 
    window.dataLayer.push({
      event: "quizProgression",
      quizStage: stage
    });
  }
}

function saveAnswer() {
  let validResponse = validateAnswer(),
    isValid = validResponse.result,
    isGut = validResponse.isGut;
  if (isValid == true) {
     //push datalayer
     console.log(currentCursor)
     pushDataLayer(currentCursor)
    //Validation Passed
    if (currentCursor == 0) {
      if (validResponse.text == 'Australia' || validResponse.text == 'Rest of the World') {
        if (location.host == 'thebeautychef.com') {
          nextStep();
        } else {
          if (validResponse.text == 'Australia') {
            window.location.href = "https://thebeautychef.com/pages/questionnaire?pos=0";
          } else {
            window.location.href = "https://thebeautychef.com/pages/questionnaire?pos=1";
          }
        }
      } else {
        if (location.host == 'us.thebeautychef.com') {
          nextStep();
        } else {
          window.location.href = "https://us.thebeautychef.com/pages/questionnaire?pos=0";
        }
      }
    } else {
      nextStep();
    }
    function nextStep() {
      if (isGut) {
        // $(gutQuestionPositions).each(function(i, gutQuestionPosition){
        //   var tmp = [];
        //   var gutQuestion = questions[gutQuestionPosition];
        //   tmp.push($(ele.gutInput + '[name="' + gutQuestion.id + '"]' + ':checked').val());
        //   gutQuestion.answered = tmp;
        //   console.log(gutQuestion);
        //   postAnswers(gutQuestion);
        // });

        gutScore = gutScoreCalculate();
        postGutScore(gutScore);

        if (gutScore > 20) {
          //generateAnswers();
          currentCursor = questions.length - 2;
          nextQuestion();
        } else {
          //Overwrite questions array's current question (This is to update it with the answer)
          //questions[currentCursor] = currentQuestion;
          nextQuestion();
        }

      } else {
        // We need to do an if statement here so that if this is the last question, we are posting 2 answers instead of 1. 	
        // If last question (){}, else do below 	
        // In here you'll need to record the answers to the questions variable before you run the postAnswer eg questions[index].answered	
        // You will run postAnswers twice, once for email, and once for the last question (the compulsory checkbox)	
        if (currentQuestion.id === questions[questions.length - 1].id) {
          currentQuestion.answered = validResponse.answer;
          //           console.log(questions[emailPosition], currentQuestion, questions, emailPosition);
          console.log(questions[emailPosition].answerType);

          if (questions[emailPosition].answerType === "email") {
            console.log("EMAIL:", questions[emailPosition].answered[0]);
            document.cookie = "tbc_quiz_e=" + questions[emailPosition].answered[0] + "; max-age=900;";;
          }

          postAnswers(questions[emailPosition]);
          postAnswers(currentQuestion);
          nextQuestion();
        } else {
          currentQuestion.answered = validResponse.answer;
          postAnswers(currentQuestion);
          //Overwrite questions array's current question (This is to update it with the answer)	
          //questions[currentCursor] = currentQuestion;	
          nextQuestion();
        }
      }
    }


  } else {
    //Validation Failed
  }
}

function validateAnswer() {
  let summary = {};
  summary.result = false;
  summary.isGut = false;
  var answerType = currentQuestion.answerType,
    errorClassName = 'error',
    inputClass = '.tbc-input--class',
    inputContainer = '.tbc-input--container',
    radioClass = '.tbc-multi--class' + ':checked',
    radioContainer = '.tbc-multi--container',
    selectClass = '.tbc-select',
    selectContainer = '.tbc-select--container',
    checkboxClass = '.tbc-multi--class' + ':checked',
    checkboxContainer = '.tbc-multi--container',
    gutContainer = '.gut__wrapper';

  if (currentCursor == 0) {
    var value = $(radioClass).closest('.tbc-radio').find('.tbc-multi--title').text();
    var tmp = [];
    tmp.push(value);
    summary.text = tmp;
  }
  if (currentCursor == firstGutQuestionPosition) {
    var gutNotAnswered = [];
    $('.gut__option label').removeClass('error');
    $(gutQuestionPositions).each(function (i, gutQuestionPosition) {
      if ($(ele.gutInput + '[name="' + questions[gutQuestionPosition].id + '"]' + ':checked').length != 1) {
        gutNotAnswered.push(questions[gutQuestionPosition].id);
      }
    });
    $(inputContainer).removeClass(errorClassName);
    if (gutNotAnswered.length === 0) {
      summary.result = true;
      summary.isGut = true;
      return summary;
    } else {
      $(gutContainer).addClass(errorClassName).animateCss("shake");
      $.each(gutNotAnswered, function (i, id) {
        console.log(id);
        $('[data-id="' + id + '"]').siblings().addClass('error');
      });
      return summary;
    }
  } else if (answerType == 'text' || answerType == 'number' || answerType == 'email') {
    //Text box
    var value = $(inputClass).val();
    $(inputContainer).removeClass(errorClassName);
    if (!value) {
      $(inputContainer).addClass(errorClassName).animateCss("shake");
      return summary;
    }
    if (answerType == "email") {
      if (!ValidateEmail($(inputClass).val())) {
        let errorMsg = '<p class="error-message">Please enter a valid email address.</p>';
        $(inputContainer).addClass(errorClassName).animateCss("shake");
        if (!$(inputContainer + ' .error-message').length) {
          $(inputContainer).append(errorMsg);
        }
        return summary;
      }
    } else if (answerType == "number") {
      if (isNaN(value)) {
        $(inputContainer).addClass(errorClassName).animateCss("shake");
        return summary;
      }
    }
    var tmp = [];
    tmp.push(value);
    summary.answer = tmp;
  } else if (answerType == "single" && currentCursor != questions.length - 1) {
    //single choice
    var value = $(radioClass).val();
    $(radioContainer).removeClass(errorClassName);
    if (!value) {
      $(radioContainer).addClass(errorClassName).animateCss("shake");
      return summary;
    }
    var tmp = [];
    tmp.push(value);
    summary.answer = tmp;
  } else if (answerType == "multi") {
    //multi choice
    $(checkboxContainer).removeClass(errorClassName);
    var tmp = [];
    $(checkboxClass).each(function (i) {
      if ($(this).hasClass('noOption')) {
        tmp = [$(this).val()];
        return false;
      } else {
        tmp.push($(this).val());
      }
    });
    if (tmp.length == 0) {
      $(checkboxContainer).addClass(errorClassName).animateCss("shake");
      return summary;
    }
    summary.answer = tmp;
  } else if (answerType == "drop") {
    //single choice
    var value = $(selectClass).val();
    $(selectContainer).removeClass(errorClassName);
    if (!value) {
      $(selectContainer).addClass(errorClassName).animateCss("shake");
      return summary;
    }
    var tmp = [];
    tmp.push(value);
    summary.answer = tmp;
    // check if last question	
  } else if (currentCursor === questions.length - 1) {
    var $tnc = $('#80-compulsory'),
      $tncContainer = $($tnc).parent('.tnc-checkbox');
    if (!ValidateEmail($(inputClass).val())) {
      //If invalid	
      let errorMsg = '<p class="error-message">Please enter a valid email address.</p>';
      $(inputContainer).addClass(errorClassName).animateCss("shake");
      if (!$(inputContainer + ' .error-message').length) {
        $(inputContainer).append(errorMsg);
      }
      console.log('invalid');
      return summary;
    }
    //If email valid remove error message	
    $(inputContainer).removeClass(errorClassName);
    $(inputContainer + ' .error-message').remove();
    questions[emailPosition].answered = [$(inputClass).val()];
    //Check and make sure tnc is ticked, if not alert to make them tick	
    if (!$tnc.is(':checked')) {
      let errorMsg = '<p class="error-message">Please accept the terms and conditions to continue.</p>'
      $tncContainer.animateCss("shake");
      $tncContainer.append(errorMsg);
      return summary;
    }
    //if ticked assign summary answer and result as 'tmp' and true respectively	
    var tmp = [],
      value = currentQuestion.options[1].id;
    if ($('#80-klaviyo').is(':checked')) {
      value = currentQuestion.options[0].id;
    }
    tmp.push(value);
    summary.answer = tmp;
    summary.result = true;
  }
  summary.result = true;
  return summary;
}

function gutScoreCalculate() {
  var result = 0;
  $(gutQuestionPositions).each(function (i, gutQuestionPosition) {
    gutQuestion = questions[gutQuestionPosition];
    answeredScore = $(ele.gutInput + '[name="' + gutQuestion.id + '"]' + ':checked').data('score');
    result += answeredScore;
  });
  return result;
}

function postGutScore(score) {
  var submitData = {
    uuid: uuid,
    score: score
  };
  function getData() {
    return $.ajax({
      type: "POST",
      url: mainurl + "/api/savescore",
      data: submitData
    });
  }
  function handleData(data) {
    var response = data;
  }
  getData().done(handleData);
}

function postGutAnswer(questionID, value) {

  $('[data-id="' + questionID + '"]').closest('.gut__option').find('label').removeClass('error');

  var tmp = [];
  let gutQuestion = getQuestionById(questionID);
  tmp.push(value);
  gutQuestion.answered = tmp;

  postAnswers(gutQuestion);
}

function postAnswers(question) {
  var submitData = {
    uuid: uuid,
    question: question.id,
    answer: question.answered
  };
  function getData() {
    return $.ajax({
      type: "POST",
      url: mainurl + "/api/saveanswer",
      data: submitData
    });
  }
  function handleData(data) {
    var response = data;
    if (!response.success) {
      alert(response.message);
    } else {
      console.log(question.answered);
    }
  }
  getData().done(handleData);
}

function generateAnswers() {
  pageload('show');
  $.ajax({
    type: "GET",
    url: mainurl + "/api/markComplete?uuid=" + uuid
  }).done(function (data) {
    console.log('UUID Marked Complete');
    $.ajax({
      type: "GET",
      url: mainurl + "/api/generateRecommendations/" + uuid
    }).done(function (data) {
      localStorage.setItem('uuid', uuid);
      console.log('Generate Recoomendations API Successful');
      window.location = "/pages/results?token=" + uuid;
    }).fail(function () {
      alert('621 An error has occured. Please contact us if error persists.')
    });
  }).fail(function () {
    alert('624 An error has occured. Please contact us if error persists.')
  });

}

function buildQuestionnaire() {
  html.header += '<div id="questionnaire-container">'
    + '<div class="header">'
    + '<div class="questionnaire__breadcrumb">'
    + '<ul>'
    + '<li id="step1" class="active"><span class="title">General Questions</span><span class="circle"></span></li>'
    + '<li id="step2"><span class="title">Main Concern</span><span class="circle"></span></li>'
    + '<li id="step3"><span class="title">Recommendations</span><span class="circle"></span></li>'
    + '<li id="step4"><span class="title">Complete</span><span class="circle"></span></li>'
    + '</ul>'
    + '</div>'
    + '<div id="quit">Exit</div>'
    + '</div>';
  html.body += '<div class="body">'
    + '<div id="tbc-title" class="title"></div>'
    + '<div id="tbc-content" class="content"></div>'
    + '</div>';
  html.footer += '<div class="footer">'
    + '<nav><div class="prev" onclick="prevQuestion()">BACK</div><div class="next" onclick="saveAnswer()">NEXT</div></nav>'
    + '</div>'
    + '</div>';
  html.complete += html.header + html.body + html.footer;

  $(html.id).append(html.complete);
}

function ValidURL(str) {
  var regex = /(http|https):\/\/(\w+:{0,1}\w*)?(\S+)(:[0-9]+)?(\/|\/([\w#!:.?+=&%!\-\/]))?/;
  if (!regex.test(str)) {
    return false;
  } else {
    return true;
  }
}

function ValidateEmail(mail) {
  if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(mail)) {
    return true;
  } else {
    return false;
  }
}

function checkboxLimit(obj, limit) {
  if (limit != 0) {
    if ($('input[id="' + obj.id + '"]').closest('#tbc-content').find(':checked').length > limit) {
      $('input[id="' + obj.id + '"]').prop('checked', false);
    }
  }
}

function shortcutKey() {
  $(window).keydown(function (event) {
    if (event.keyCode == 13 || event.keyCode == 39) {
      event.preventDefault();
      saveAnswer();
      return false;
    } else if (event.keyCode == 37) {
      event.preventDefault();
      prevQuestion();
      return false;
    } else if (event.keyCode == 27) {
      //exit
    }
  });
}

function prevQuestion() {
  if (answerOrder.length != 1) {
    answerOrder.pop();
    if (
      categorySelectionQuestion != null &&
      categorySelectionQuestion == questions[answerOrder.length - 1].question.id
    ) {
      answerOrder.pop();
      categorySelectionQuestion = null;
    }
    nextQuestion(true);
  }
}

$.fn.extend({
  animateCss: function (animationName, callback) {
    var animationEnd = (function (el) {
      var animations = {
        animation: "animationend",
        OAnimation: "oAnimationEnd",
        MozAnimation: "mozAnimationEnd",
        WebkitAnimation: "webkitAnimationEnd"
      };

      for (var t in animations) {
        if (el.style[t] !== undefined) {
          return animations[t];
        }
      }
    })(document.createElement("div"));

    this.addClass("animated " + animationName).one(animationEnd, function () {
      $(this).removeClass("animated " + animationName);

      if (typeof callback === "function") callback();
    });

    return this;
  }
});